var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 42,
    viewBox: "0 0 231 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1122_2824)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.3303,
    width: 187.571,
    height: 34.5348,
    fill: "#FFBD3D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4432,
    y: 0.112859,
    width: 187.346,
    height: 34.3091,
    stroke: "#AEE4E6",
    strokeWidth: 0.225718
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.7749 9.05473H77.7466C79.1025 9.05473 80.0914 9.37374 80.7135 10.0118C81.3356 10.6338 81.6466 11.5989 81.6466 12.9068V13.5768C81.6466 14.4381 81.503 15.1399 81.2159 15.6823C80.9448 16.2246 80.5221 16.6154 79.9478 16.8546V16.9025C81.2558 17.3491 81.9098 18.5135 81.9098 20.3957V21.8313C81.9098 23.1233 81.5668 24.1122 80.881 24.7981C80.211 25.468 79.2221 25.803 77.9141 25.803H73.7749V9.05473ZM77.4356 15.8737C77.962 15.8737 78.3528 15.7381 78.608 15.4669C78.8791 15.1958 79.0147 14.7412 79.0147 14.1031V13.17C79.0147 12.5639 78.9031 12.1252 78.6798 11.8541C78.4724 11.5829 78.1374 11.4473 77.6749 11.4473H76.4068V15.8737H77.4356ZM77.9141 23.4104C78.3767 23.4104 78.7196 23.2907 78.9429 23.0515C79.1663 22.7963 79.2779 22.3656 79.2779 21.7595V20.3C79.2779 19.5343 79.1423 19.008 78.8712 18.7209C78.616 18.4178 78.1853 18.2663 77.5792 18.2663H76.4068V23.4104H77.9141ZM83.4481 9.05473H90.626V11.4473H86.08V15.8737H89.6929V18.2663H86.08V23.4104H90.626V25.803H83.4481V9.05473ZM95.6082 26.0422C94.3321 26.0422 93.3671 25.6833 92.7131 24.9656C92.0592 24.2318 91.7322 23.1871 91.7322 21.8313V20.8742H94.2205V22.0227C94.2205 23.1073 94.6751 23.6496 95.5843 23.6496C96.0309 23.6496 96.3659 23.522 96.5892 23.2668C96.8284 22.9957 96.9481 22.565 96.9481 21.9748C96.9481 21.273 96.7886 20.6589 96.4695 20.1325C96.1505 19.5902 95.5603 18.9442 94.699 18.1945C93.6144 17.2374 92.8567 16.3761 92.426 15.6105C91.9954 14.8289 91.78 13.9516 91.78 12.9786C91.78 11.6547 92.115 10.6339 92.7849 9.91607C93.4549 9.18233 94.4278 8.81547 95.7039 8.81547C96.964 8.81547 97.9131 9.18233 98.5511 9.91607C99.2051 10.6339 99.5321 11.6706 99.5321 13.0265V13.7203H97.0438V12.859C97.0438 12.2847 96.9321 11.87 96.7088 11.6148C96.4855 11.3437 96.1585 11.2081 95.7278 11.2081C94.8505 11.2081 94.4119 11.7424 94.4119 12.8111C94.4119 13.4172 94.5714 13.9835 94.8904 14.5099C95.2254 15.0362 95.8235 15.6743 96.6849 16.424C97.7855 17.381 98.5431 18.2503 98.9578 19.0319C99.3726 19.8135 99.5799 20.7307 99.5799 21.7834C99.5799 23.1552 99.237 24.2079 98.5511 24.9416C97.8812 25.6754 96.9002 26.0422 95.6082 26.0422ZM103.147 11.4473H100.395V9.05473H108.53V11.4473H105.778V25.803H103.147V11.4473ZM112.942 9.05473H115.598L117.321 22.0466H117.369L119.091 9.05473H121.508L118.972 25.803H115.478L112.942 9.05473ZM124.128 9.05473H127.693L130.421 25.803H127.789L127.31 22.4773V22.5251H124.319L123.841 25.803H121.401L124.128 9.05473ZM126.999 20.2521L125.827 11.9737H125.779L124.631 20.2521H126.999ZM131.697 9.05473H134.329V23.4104H138.66V25.803H131.697V9.05473ZM143.75 26.0422C142.474 26.0422 141.501 25.6833 140.831 24.9656C140.161 24.2318 139.826 23.1871 139.826 21.8313V9.05473H142.458V22.0227C142.458 22.5969 142.57 23.0116 142.793 23.2668C143.032 23.522 143.367 23.6496 143.798 23.6496C144.229 23.6496 144.556 23.522 144.779 23.2668C145.018 23.0116 145.138 22.5969 145.138 22.0227V9.05473H147.674V21.8313C147.674 23.1871 147.339 24.2318 146.669 24.9656C145.999 25.6833 145.026 26.0422 143.75 26.0422ZM149.549 9.05473H156.726V11.4473H152.18V15.8737H155.793V18.2663H152.18V23.4104H156.726V25.803H149.549V9.05473Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9883 34.3091V41.1927L21.6689 34.3091H27.9883Z",
    fill: "#986A10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5459H21.6689V34.3092L27.989 41.1936H0L10.8344 24.039L0 6.5459Z",
    fill: "#FFDD9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.582 34.3091V41.1927L208.902 34.3091H202.582Z",
    fill: "#986A10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M230.571 6.5459H208.902V34.3092L202.582 41.1936H230.571L219.736 24.039L230.571 6.5459Z",
    fill: "#FFDD9C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1122_2824",
    x: 20.8789,
    y: -0.451435,
    width: 188.474,
    height: 35.4378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.225718
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1122_2824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1122_2824",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestValue);
export default __webpack_public_path__ + "static/media/best-value.d5d7341c0426f286a2bc26e787a48802.svg";
export { ForwardRef as ReactComponent };